import { ApiUserActionType, ApiUserFilterType } from "@incendium/api";
import { ExtraUserActionType } from "features/leadAnalytics/types/types";

export const actionTypeToName = (
  t: ApiUserActionType | ExtraUserActionType,
) => {
  switch (t) {
    case ExtraUserActionType.VISIT_START:
      return "Visit";
    case ExtraUserActionType.VISIT_END:
      return "Visit End";
    case ExtraUserActionType.GPROUPED_INTERACTION:
      return "Interactions";
    case ExtraUserActionType.MACRO_CONVERSION:
      return "Conversion";
    case ExtraUserActionType.MICRO_CONVERSION:
      return "Interactionn";
    case ApiUserActionType.PAGE_VIEW:
      return "Pageview";
    case ApiUserActionType.LEAD_SCORE:
      return "New Lead Score";
    case ApiUserActionType.LEAD_STATUS:
      return "New Lead Status";
    case ApiUserActionType.RETENTION:
      return "Retention Calculation";

    default:
      return "";
  }
};

export const leadDimensionToName = (t: ApiUserFilterType) => {
  switch (t) {
    case ApiUserFilterType.AUDIENCE:
      return "Audience";
    case ApiUserFilterType.DEVICE:
      return "Device";
    case ApiUserFilterType.LEAD_SCORE:
      return "Lead Score";
    case ApiUserFilterType.LTV:
      return "LTV";
    case ApiUserFilterType.MACRO_CONVERSION:
      return "Conversions";
    case ApiUserFilterType.MICRO_CONVERSION:
      return "Interactions";
    case ApiUserFilterType.PRODUCT:
      return "Seen Products";
    case ApiUserFilterType.SALES:
      return "No. Of Sales";
    case ApiUserFilterType.MICRO_CONVERSION_COUNT:
      return "No. Of Interactions";
    case ApiUserFilterType.MACRO_CONVERSION_COUNT:
      return "No. Of Conversions";
    case ApiUserFilterType.STATUS:
      return "Current Lead Status";
    case ApiUserFilterType.FIRST_SOURCE:
      return "First Source";
    case ApiUserFilterType.HAS_SOURCE:
      return "Has Source";
    case ApiUserFilterType.FIRST_CAMPAIGN:
      return "First Campaign";
    case ApiUserFilterType.HAS_CAMPAIGN:
      return "Has Campaign";
    case ApiUserFilterType.FIRST_CHANNEL:
      return "First Channel";
    case ApiUserFilterType.HAS_CHANNEL:
      return "Has Channel";
    case ApiUserFilterType.HAS_LOCATION:
      return "Visited Location";
    default:
      return "";
  }
};
